import { FC, SVGAttributes } from 'react';

const Igaming: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_20302_77611)">
                <path
                    d="M12.1375 20.2745C12.2055 20.8703 12.473 21.4257 12.8966 21.8502C13.3202 22.2747 13.8749 22.5435 14.4707 22.6127C15.3775 22.7139 16.3084 22.8013 17.2564 22.8013C18.2061 22.8013 19.1352 22.7139 20.0421 22.6127C20.6378 22.5435 21.1925 22.2747 21.6161 21.8502C22.0397 21.4257 22.3073 20.8703 22.3752 20.2745C22.4712 19.3727 22.5535 18.447 22.5535 17.5042C22.5535 16.5613 22.4712 15.6356 22.3752 14.7339C22.3073 14.1383 22.0401 13.5831 21.6168 13.1586C21.1936 12.7341 20.6392 12.4652 20.0438 12.3956C19.1188 12.2823 18.1882 12.2193 17.2564 12.207C16.3084 12.207 15.3775 12.2945 14.4707 12.3956C13.8753 12.4652 13.3209 12.7341 12.8976 13.1586C12.4744 13.5831 12.2071 14.1383 12.1392 14.7339C12.03 15.6534 11.9704 16.5782 11.9609 17.5042C11.9609 18.447 12.0415 19.3727 12.1375 20.2745Z"
                    stroke="#282828"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.3516 18.603V19.4259M19.0853 15.207V16.0299"
                    stroke="#282828"
                    strokeWidth="1.71429"
                    strokeLinecap="round"
                />
                <path
                    d="M16.1572 8.71386C15.5914 6.59843 14.8166 4.603 14.1069 2.68129C13.966 2.30489 13.702 1.98714 13.3579 1.77958C13.0137 1.57203 12.6095 1.48685 12.2109 1.53786C10.5583 1.74872 8.82688 1.93557 7.11945 2.39329C5.41202 2.84929 3.82116 3.55386 2.28516 4.19672C1.91343 4.35147 1.60503 4.62749 1.41018 4.97986C1.21532 5.33222 1.14547 5.74017 1.21202 6.13729C1.55659 8.155 1.88573 10.2704 2.45145 12.3859C3.01716 14.5013 3.79202 16.4967 4.50173 18.4167C4.64239 18.7938 4.90647 19.1121 5.25101 19.32C5.59556 19.5279 6.00031 19.6132 6.39945 19.5619C7.20859 19.459 8.03659 19.3613 8.87316 19.2344M20.3109 8.80986C20.3109 8.80986 20.7326 6.44414 20.9297 5.299C20.996 4.90235 20.9262 4.49495 20.7317 4.14298C20.5372 3.791 20.2294 3.51512 19.8583 3.36014C19.0612 3.02586 18.2469 2.67443 17.412 2.35043"
                    stroke="#282828"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.9486 9.81839L8.44979 7.28125L6.6875 11.2292L9.11836 13.0241"
                    stroke="#282828"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_20302_77611">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Igaming;
